import { render, staticRenderFns } from "./OldStoreLayout.vue?vue&type=template&id=6ff00514&scoped=true"
import script from "./OldStoreLayout.vue?vue&type=script&lang=js"
export * from "./OldStoreLayout.vue?vue&type=script&lang=js"
import style0 from "./OldStoreLayout.vue?vue&type=style&index=0&id=6ff00514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff00514",
  null
  
)

export default component.exports